/** Correlation/deduplication only; never an authentication credential. */
export function createRequestId(): string {
  if (typeof globalThis.crypto?.randomUUID === 'function') return globalThis.crypto.randomUUID();
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (key) => {
    const value = Math.floor(Math.random() * 16);
    return (key === 'x' ? value : (value & 3) | 8).toString(16);
  });
}
